import PropTypes from 'prop-types'
import { useSetAtom } from 'jotai'
import {
  currentSiteAtom,
  globalSettingsAtom,
  sitesAtom,
  siteSlugAtom,
} from '../../lib/atoms'
import { useEffect } from 'react'

export default function StateInitializer({
  children,
  globalSettings,
  sites,
  siteSlug = null,
}) {
  // 3. Get the setter function for each atom
  const setGlobalSettings = useSetAtom(globalSettingsAtom)
  const setSites = useSetAtom(sitesAtom)
  const setCurrentSite = useSetAtom(currentSiteAtom)
  const setSiteSlug = useSetAtom(siteSlugAtom)

  // This logic to derive currentSite is still correct
  let currentSite = null
  if (sites && siteSlug) {
    currentSite = sites.find((s) => {
      const pathParts = s.path.split('/').filter((p) => p !== '')
      return pathParts[pathParts.length - 1] === siteSlug
    })
  }

  // 4. Use an effect to update atoms whenever props change
  useEffect(() => {
    setGlobalSettings(globalSettings)
    setSites(sites)
    setCurrentSite(currentSite)
    setSiteSlug(siteSlug)
  }, [
    globalSettings,
    sites,
    currentSite,
    siteSlug,
    setGlobalSettings,
    setSites,
    setCurrentSite,
    setSiteSlug,
  ])

  return <>{children}</>
}

StateInitializer.propTypes = {
  children: PropTypes.node.isRequired,
  globalSettings: PropTypes.shape({
    offices: PropTypes.object,
    mainMenu: PropTypes.object,
    footerMenu: PropTypes.object,
    globalOptions: PropTypes.object,
  }).isRequired,
  sites: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      units: PropTypes.oneOf(['metric', 'imperial']),
      businessUnit: PropTypes.oneOf(['select', 'modellink']).isRequired,
    })
  ).isRequired,
  siteSlug: PropTypes.string,
}
